import React, { ReactNode } from 'react';
import { IconButton, Typography } from '@mui/material';
import { yellow } from '@mui/material/colors';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

interface Props {
  doc: any;
  onEdit: VoidFunction;
  onDelete: VoidFunction;
  specialPanel?: ReactNode | null;
  isRoleAllowed?: boolean;
  hideDelete?: boolean;
}

export const MobileCardActionPanel = ({
  doc,
  onEdit,
  onDelete,
  specialPanel,
  isRoleAllowed = true,
  hideDelete = false,
}: Props) => {
  if (specialPanel) return <>{specialPanel}</>;

  return (
    <>
      {doc?.source ? (
        isRoleAllowed ? (
          <>
            <IconButton size="small" href={doc.source} target="_blank">
              <VerticalAlignBottomIcon fontSize="small" color="primary" />
            </IconButton>
            <IconButton size="small" onClick={onEdit}>
              <EditIcon fontSize="small" color="primary" />
            </IconButton>
            {!hideDelete && (
              <IconButton size="small" onClick={onDelete}>
                <DeleteOutlineIcon fontSize="small" color="error" />
              </IconButton>
            )}
          </>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Access restricted
          </Typography>
        )
      ) : (
        <IconButton size="small" disabled>
          <ReportProblemOutlinedIcon fontSize="small" style={{ color: yellow['700'] }} />
        </IconButton>
      )}
    </>
  );
};
